export default __webpack_public_path__ + "static/media/nav-close-tab.18fcecc7.svg";